<template>
  <b-row v-if="$store.state.user.cards.length" style="padding-bottom:40px;">
    <b-col style="padding:0px;">
      <b-row align-v="center" style="margin:16px 8px;" v-for="(card, idxa) in $store.state.user.cards" v-bind:key="idxa">
        <b-col cols="2">
          <input type="radio" name="address_choice" style="width:20px;height:20px;" :checked="amIselected(card.id)" @change="selectCard(card.id)"/>
        </b-col>
        <b-col cols="2">
          <font-awesome-icon style="color:#525962;font-size:24px;" :icon="[cardLib(card.flag), cardIcon(card.flag)]"/>
        </b-col>
        <b-col cols="8" style="
        font-style: normal;
        font-weight: normal;
        line-height: 17px;
        font-size: 14px;
        letter-spacing: -0.08px;
        color: #525962;
        ">
          <span style="
          font-weight: 500;
          font-size: 15px;
          color: #121C2A;">
          {{card.name}}
          </span><br/>
          {{card.number}}
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col style="
    margin-top:23px;
    font-style: normal;
    font-weight: normal;
    line-height: 17px;
    font-size: 14px;
    text-align: center;
    color: #525962;
    ">
      Cartão não encontrado.<br/>
      Clique em cadastrar novo cartão para adicionar
    </b-col>
  </b-row>
</template>

<script>
import formaters from '@/mixins/formaters'
export default {

  data () {
    return {
      selectedId: 0
    }
  },

  mixins: [formaters],

  created () {
    if (this.$store.state.user.cards.length) {
      this.selectedId = this.$store.state.user.cards[this.$store.state.user.cards.length-1].id
      this.selectCard(this.selectedId)
    }
  },

  methods: {
    amIselected (cardId) {
      let amI = (cardId === this.selectedId)
      return amI
    },

    selectCard (cardId) {
      this.selectedId = cardId
      this.$emit('selectedCard', cardId)
    }
  }

}
</script>

<style>

</style>
